import { RESULTS_PER_PAGE } from 'search/enums/constants';

export const getPageNumber = (resultsCount, resultsPerPage = RESULTS_PER_PAGE) => {
  if (resultsCount === 0) {
    return 1;
  }

  if (resultsCount % resultsPerPage === 0) {
    return resultsCount / resultsPerPage;
  }

  if (resultsCount % resultsPerPage > 0) {
    return Math.floor(resultsCount / resultsPerPage) + 1;
  }

  return 1;
};
